import { Skeleton } from '@ria-client/tw-shadcn/components/skeleton';

export interface ProductCardRedesignSkeletonProps {
  ourTakeExpanded?: boolean;
}

export function ProductCardRedesignSkeleton({
  ourTakeExpanded = false,
}: ProductCardRedesignSkeletonProps) {
  return (
    <div>
      <div className="relative mb-3.5 hidden rounded-sm border border-border md:flex md:flex-wrap">
        <div className="w-full px-3.5 pb-1 pt-3.5">
          <div className="flex items-center pb-4">
            <Skeleton className="h-10 w-[250px] rounded" />
          </div>
          <div className="flex w-full items-center gap-4 pb-3">
            <Skeleton className="h-[88px] w-[244px] rounded" />
            <div className="flex flex-1 flex-col gap-2">
              <Skeleton className="h-[30px] w-[350px] rounded" />
              <Skeleton className="h-[25px] w-[250px] rounded" />
            </div>
            <div className="flex flex-col items-center justify-center gap-2">
              <Skeleton className="mb-1 h-[50px] w-[250px] rounded" />
              <Skeleton className="h-5 w-[150px] rounded" />
              <Skeleton className="h-5 w-[250px] rounded" />
            </div>
          </div>
          <div className="flex w-full items-center justify-between">
            {Array.from({ length: 4 }).map((_, index) => (
              <div className="w-1/4 px-2" key={index}>
                <Skeleton className="h-[75px] w-full rounded" />
              </div>
            ))}
          </div>
        </div>
        <div className="flex w-full border-t border-border py-3">
          <Skeleton className="ml-3.5 mr-2 h-[27px] w-[30px] rounded" />
          <Skeleton className="h-[27px] w-[250px] rounded" />
        </div>
        {ourTakeExpanded && (
          <div className="flex w-full px-3.5 pb-3.5 pt-2">
            <div
              className="flex h-[632px] w-full flex-col gap-3 p-3"
              data-testid="product-card-redesign-skeleton-details"
            >
              {Array.from({ length: 6 }).map((_, index) => (
                <Skeleton className="h-20 w-full rounded" key={index} />
              ))}
              <Skeleton className="h-6 w-[130px] rounded" />
            </div>
          </div>
        )}
      </div>
      <div className="relative mb-3.5 rounded-sm border border-border md:hidden">
        <div className="flex flex-col gap-3 px-3 pb-1 pt-3">
          <Skeleton className="h-10 w-full rounded" />
          <Skeleton className="h-[25px] w-[250px] rounded" />
          <div className="mb-2 flex items-center justify-center gap-x-3">
            <Skeleton className="h-[56px] w-[155px] rounded" />
            <div className="flex flex-col gap-2">
              <Skeleton className="h-[15px] w-[125px] rounded" />
              <Skeleton className="h-5 w-[125px] rounded" />
            </div>
          </div>
          <div className="flex flex-col items-center gap-2">
            <Skeleton className="h-[45px] w-full rounded" />
            <Skeleton className="h-[15px] w-[250px] rounded" />
            <Skeleton className="h-5 w-full rounded" />
          </div>
          <div className="flex flex-wrap justify-center gap-2">
            {Array.from({ length: 4 }).map((_, index) => (
              <Skeleton
                className="h-[90px] w-[calc(41.666667%_-_4.666667px)] rounded"
                key={index}
              />
            ))}
          </div>
        </div>
        <div className="flex border-t border-border py-3">
          <Skeleton className="ml-3 mr-2 h-[25px] w-[30px] rounded" />
          <Skeleton className="h-[25px] w-[250px] rounded" />
        </div>
        {ourTakeExpanded && (
          <div
            className="flex h-[1135px] w-full flex-col gap-3 p-3.5"
            data-testid="product-card-redesign-skeleton-details"
          >
            {Array.from({ length: 10 }).map((_, index) => (
              <Skeleton className="h-[100px] w-full rounded" key={index} />
            ))}
            <Skeleton className="h-6 w-full rounded" />
          </div>
        )}
      </div>
    </div>
  );
}
